import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Modal, Button } from "react-bootstrap";
import APICom from "../../../utils/helpers/APICom";
import ConfirmationModal from "../../Controls/ConfirmationModal";
import CommonFunctions from "../../../utils/helpers/CommonFunctions";

const UnRoute = (props) => {
    const { AffiliateData,GlobalASCSData } = useSelector((store) => store.combinedata);
    const [showUnRouteAlert, setUnRouteAlert] = useState(false);
    const [unRouteAlertObj, setunRouteAlertObj] = useState({ alertTitle: '', alertMsg: '', displayFooter: true });
    const { loginData } = useSelector((store) => store.login);
    const [confirmationModalObj, setConfirmationModalObj] = useState({show: false, title:'Auto Routing',
    body:'Are you Sure you want to Pause Auto-Routing?', btnCanceText: 'No',
    btnOkText: 'Yes'});
 
    useEffect(() => {
        async function fetchData(){
        if (props.GridRowData === null || props.GridRowData.length <= 0) {
            setunRouteAlertObj({ ...unRouteAlertObj, alertTitle: 'UnRoute Action', alertMsg: 'No request selected to perform Action.' , displayFooter: true});
            setUnRouteAlert(true);
        }
        else {
            let result = await CommonFunctions.checkAutoRouting(props.selectedAffiliates, props.selectedDate, AffiliateData);
            if(result){
                setConfirmationModalObj((prevState) => ({...prevState, show:true, title:'Auto Routing', body:'Are you Sure you want to Pause Auto-Routing?', btnCanceText: 'No', btnOkText: 'Yes'}));
            }else{
                await UnRouteActions();
            }
        }

    }
            fetchData();
    }, []);

    const UnRouteActions = async() =>{
        try{
            const selectedGridData = props.GridRowData
            const affID = selectedGridData[0].iSRATSPID;
            let callBackURL = "";
            const SelectedRecordsForARB = [];
            if (GlobalASCSData !== null && GlobalASCSData !== undefined) {
                const jsonArray = GlobalASCSData;
                const URL = jsonArray.find(item => item.SubTitle === "AsteriskServerToClientCommAPI_URL");
                callBackURL = URL.value + '/WMRMSCommonAPI/SendMessageToWMRMS';
            }
            let bschedule = "";
            for (let k = 0; k < selectedGridData.length; k++) {
                if (selectedGridData[k].Route !== "") {
                    bschedule = (typeof selectedGridData[k].bIsSchedule === "boolean" ? (selectedGridData[k].bIsSchedule === true ? true:false):(selectedGridData[k].bIsSchedule.toUpperCase() === "TRUE" ? true : false));
                    SelectedRecordsForARB.push({
                        PickupDateTime: selectedGridData[0].PickupDateTime,
                        AffiliateID: selectedGridData[k].iSRATSPID,
                        ServiceID: (!bschedule?selectedGridData[k].ServiceID:-1),
                        ScheduleID: (bschedule?selectedGridData[k].iScheduleID:-1),
                        Confirmation: selectedGridData[k].ConfirmationNo,
                        vManifestNumber: selectedGridData[k].vManifestNumber,
                        TripRequestStatus: selectedGridData[k].TripRequestStatus,
                        iAssignedVehicleId: selectedGridData[k].iAssignedVehicleId === "" ? "-1" : selectedGridData[k].iAssignedVehicleId,
                        iAssignedDriverId: selectedGridData[k].AssignedDriverId === "" ? "-1" : selectedGridData[k].AssignedDriverId,
                    });
                }
            }

            if (SelectedRecordsForARB.length === 0) {
                setunRouteAlertObj({ ...unRouteAlertObj, alertTitle: 'UnRoute', alertMsg: 'No grouped record is selected. Please select valid grouped record(s) to perform this action!' , displayFooter: true});
                setUnRouteAlert(true);
                return false;
            }

            if (props.showUnRouteActionCreate) {
                UnRouteTrips(affID, callBackURL, SelectedRecordsForARB);
            }
        }
        catch(err){console.log(err);}
    }
    const UnRouteTrips = async (affID, cbURL, arrObj) => {
        props.disbaleButton(true);
        let Param = {
            "affiliate_id": affID,
            "requested_page_name": "UnClusteringAction",
            "user_id": loginData.iUserID,
            "app_id": 26,
            "object_list": JSON.stringify(arrObj),
            "call_back_url": cbURL
        }
        setunRouteAlertObj({ ...unRouteAlertObj, alertTitle: 'Initializing UnRouting Process', alertMsg: 'Please Wait...' , displayFooter: false});
        setUnRouteAlert(true);
        props.disbaleButton(true);
        let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/UnRoute", "post", { "Content-Type": "application/json" }, Param, null);
        let result = response.data;
        if (result.run_id > 0) {
            setunRouteAlertObj({ ...unRouteAlertObj, alertTitle: 'UnRouting Started', alertMsg: 'UnRouting is being performed...' , displayFooter: false});
            setUnRouteAlert(true);
            props.disbaleButton(true);
        }
        else if (result.error_message !== null && result.error_message !== "") {
            setunRouteAlertObj({ ...unRouteAlertObj, alertTitle: 'Un-Route', alertMsg: result.error_message , displayFooter: true});
            setUnRouteAlert(true);
            props.disbaleButton(false);
            setConfirmationModalObj((prevState) => ({...prevState, show:false}));
            handleRouteAlertClose();
        }
        else {
            setunRouteAlertObj({ ...unRouteAlertObj, alertTitle: 'Un-Route', alertMsg: 'Something went wrong !!!' , displayFooter: true});
            setUnRouteAlert(true);
            props.disbaleButton(false);
            setConfirmationModalObj((prevState) => ({...prevState, show:false}));
            handleRouteAlertClose();

        }
    }

    const handleRouteAlertClose = () => {
        setUnRouteAlert(false);
        UnMountUnRouteComponent();
    }

    const UnMountUnRouteComponent = () => {
        if (props.showRouteActionCreate) {
            props.setUnRouteActionCreate(false);
        }
    }

    const handleConfirmationModalOk = () =>{
        CommonFunctions.SaveRBSStatus(1, props.selectedDate, props.selectedAffiliates, loginData.iUserID);
        setConfirmationModalObj((prevState) => ({...prevState, show:false}));
        UnRouteActions();
    }

    const handleConfirmationModalCancel = () =>{
        setConfirmationModalObj((prevState) => ({...prevState, show:false}));
        props.setUnRouteActionCreate(false)
    }
    
    const handleConfirmationModalClose = () => {
        setConfirmationModalObj((prevState) => ({ ...prevState, show: false }));
        props.setUnRouteActionCreate(false)
    }

    return (
        <>
            {showUnRouteAlert && <Modal centered keyboard={false} show={showUnRouteAlert} backdrop="static" animation={true} onHide={handleRouteAlertClose} >
                <Modal.Header>
                    <Modal.Title>{unRouteAlertObj.alertTitle}</Modal.Title>
                </Modal.Header>
                <Modal.Body><b>{unRouteAlertObj.alertMsg}</b></Modal.Body>
                {unRouteAlertObj.displayFooter?
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleRouteAlertClose}>
                            Close
                        </Button>
                    </Modal.Footer>
                :""}
            </Modal>}

            <ConfirmationModal show={confirmationModalObj.show} Title={confirmationModalObj.title} Body={confirmationModalObj.body}
            onOk={handleConfirmationModalOk} onCancel={handleConfirmationModalCancel} onClose={handleConfirmationModalClose} btnCanceText={confirmationModalObj.btnCanceText}
            btnOkText={confirmationModalObj.btnOkText} ShowCancelButton="true" />
        </>
    );

};

export default UnRoute;